import { useWorkingPlatform } from '@repo/platform';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import DecisionErrorEqualTinContent from '@/components/tax-refund/individual/DecisionRefund/Error/DecisionErrorEqualTinContent';
import { useExitService } from '@/lib/hooks/use-exit-service';

const ErrorPage = () => {
  const router = useRouter();
  const { workingPlatformType } = useWorkingPlatform();
  const { exitService } = useExitService();

  const handleClickExit = () => {
    if (workingPlatformType === 'web') {
      router.push({
        pathname: '/home/landing',
        query: router.query
      });
    } else {
      exitService();
    }
  };
  return (
    <AuthGuard>
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <DecisionErrorEqualTinContent />
      </Layout>
    </AuthGuard>
  );
};

export default ErrorPage;
